const thisShoe = window.location.pathname;
const myBontsLink = document.getElementById('mybonts-link');

function shoeLink(shoePath){
    if (shoePath.includes('helix')) {
        return 'https://mybonts.bontcycling.com/model/helix';
    } else if (shoePath.includes('vaypor-full-custom') || shoePath.includes('vaypor-semi-custom')) {
        return 'https://mybonts.bontcycling.com/model/vaypor-plus';
    } else if (shoePath.includes('zero')) {
        return 'https://mybonts.bontcycling.com/model/zero-plus';
    } else if (shoePath.includes('vaypor-s')) {
        return 'https://mybonts.bontcycling.com/model/vaypor-s';
    } else if (shoePath.includes('vaypor-g')) {
        return 'https://mybonts.bontcycling.com/model/vaypor-g';
    } else if (shoePath.includes('vaypor-t')) {
        return 'https://mybonts.bontcycling.com/model/vaypor-t';
    } else {
        return;
    }
};

myBontsLink.setAttribute('href', shoeLink(thisShoe));

let mybontSelections = window.location.search;
let colorContainer = document.querySelector('.color-selections');
const propertiesObject = {
  'main-panel': null,
  'front-panel': null,
  'outer-panel': null,
  'inner-panel': null,
  'rear-panel': null,
  'lace-cover': null,
  'tongue': null,
  'logos': null,
  'stripes': null,
  'front-stripe': null,
  'middle-stripe': null,
  'rear-stripe': null,
  'liner': null,
  'mesh': null,
  'printing': null,
  'stitching': null,
  'decorative-stitching': null,
  'graphics': null,
  'logo-embroidery': null,
  'boa-color': null,
  'laces': null,
  'buckle': null,
  'embroidery': null,
  'embroidery-color': null,
};

const propertiesResource = Object.assign(propertiesObject, queries);

for (const property in propertiesResource) {
    if (propertiesResource[property] === null) {
      continue;
    } else {
      if (property == 'front-panel' || property == 'outer-panel' || property == 'main-panel' || property == 'rear-panel' ||  property == 'inner-panel' || property == 'printing' || property == 'laces' || property == 'stitching' || property == 'decorative-stitching' || property == 'stripes' || property == 'front-stripe' || property == 'middle-stripe'|| property == 'rear-stripe' || property == 'embroidery-color' || property == 'embroidery' || property == 'graphics' || property == 'logos' || property == 'tongue' || property == 'lace-cover' || property == 'buckle' || property == 'mesh' || property == 'liner' || property == 'logo-embroidery' || property == 'boa-color') {
          let part = property.split('-').join(' ')
          let partColor = propertiesResource[property];
          let partCapitalized = part.charAt(0).toUpperCase() + part.slice(1);
          if(partCapitalized == 'Printing') { partCapitalized = '3D Printing' }
          if(partCapitalized == 'Boa color') { partCapitalized = 'BOA Color' }
          let propDiv = `<div><span class="part">${partCapitalized}</span><span class="selected-color">${partColor.replace('%20',' ')}</span></div><input type="hidden" name="properties[${partCapitalized}]" value="${partColor.replace('%20',' ')}">`;
          let propFragment = document.createRange().createContextualFragment(propDiv);
          colorContainer.appendChild(propFragment);
      }
    }
}

if (window.location.href.indexOf("embroidery") > -1) {
    
}

if(mybontSelections.length > 0 && mybontSelections.indexOf("embroidery") > -1) {
    let mybontUrl = shoeLink(thisShoe) + mybontSelections;
    myBontsLink.setAttribute('href',mybontUrl);
    document.querySelector('.mybonts').innerHTML = `<span><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check-circle" class="svg-inline--fa fa-check-circle fa-w-16 mybonts-icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path></svg>Customized with MyBonts</span>`;
    const designUrl = document.createElement('input');
    designUrl.setAttribute('type','hidden');
    designUrl.setAttribute('name','properties[_View design]');
    designUrl.setAttribute('value', mybontUrl);
    colorContainer.appendChild(designUrl);

}